import { createContext, useContext, useMemo } from 'react';

const MediaCenterPathContext = createContext();

export const useMediaCenterPathContext = () =>
  useContext(MediaCenterPathContext);

export const MediaCenterPathProvider = ({ children, configUrls }) => {
  const {
    media_center_path: mediaCenterPath,
    media_center_folder_url: mediaCenterFolderPath,
    media_center_file_url: mediaCenterFilePath,
  } = configUrls;

  const providerState = useMemo(
    () => ({
      mediaCenterPath,
      mediaCenterFolderPath,
      mediaCenterFilePath,
    }),
    [mediaCenterPath, mediaCenterFolderPath, mediaCenterFilePath],
  );

  return (
    <MediaCenterPathContext.Provider value={providerState}>
      {children}
    </MediaCenterPathContext.Provider>
  );
};

export default MediaCenterPathContext;
